import { DependencyList, EffectCallback, useEffect, useRef } from "react";

/**
 * Use effect only when deps change (not on mount)
 * @param effect
 * @param deps
 */
export const useDidUpdateEffect = (
  effect: EffectCallback,
  deps: DependencyList
): void => {
  const mounted = useRef(false);

  useEffect(
    () => {
      if (!mounted.current) {
        mounted.current = true;
      } else {
        effect();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  );
};
